import { useMutation } from '@tanstack/react-query';
import { updateCallStatus as updateCallStatusService } from '../../api/AgentCenterAPI';

export const useUpdateCallStatus = () => {
    const {
        mutateAsync: updateCallStatus,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: updateCallStatusService,
    });

    return { updateCallStatus, isPending, ...rest };
};
